import styled, { css } from 'styled-components';
import { QuestionIcon } from '../../common/QuestionMarkIcon';
import { Button as VendorButton } from '@check24/form';
import CTA_BORDER_RADIUS from '../../../../common/js/constants/ctaBorderRadius.constant';

/*
 * Styling
 */
const UndefinedContractsWrapper = styled.div`
    position: relative;
    padding: 0 10px;
    margin-bottom: 30px;

    select {
        background-color: transparent;
    }
`;

const TitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px 0 10px 0;

    &.title-margin-top {
        margin-top: 0;
        padding-top: 20px;
    }
`;

const Title = styled.div`
    font-size: 20px;
    line-height: 30px;
    color: #949494;
`;

const ColumnButton = styled.div`
    flex: 0 0 auto;
    min-width: 290px;
    align-items: center;
    margin-top: 4px;

    button {
        padding: 0 25px;
        font-size: 20px;
        font-weight: 400;
        height: 50px;
    }
`;

const PrimaryAlternativeButtonStyle = styled(VendorButton.Mobile.Primary)`
    border-radius: ${CTA_BORDER_RADIUS};
    border: 1px solid #0563c1;
    color: #0563c1;
    background-color: #ffffff;

    &:hover,
    &:hover:active {
        color: #0563c1;
        background-color: #fafafa;
    }

    &:active,
    &:active:hover {
        color: #0563c1;
        background-color: #fafafa;
    }

    &:focus,
    &:focus:hover {
        color: #0563c1;
        background-color: #fafafa;
    }
`;

const Error = styled.div`
    color: #c82d2d;
    font-size: 14px;
    margin-top: -10px;
    margin-bottom: 15px;
`;

const PageSpinnerOverlay = styled.div<{ showPageSpinner: boolean }>`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: none;

    ${({ showPageSpinner }) =>
        showPageSpinner &&
        css`
            display: block;
        `};
`;

const PageSpinnerContainer = styled.div`
    background: rgba(244, 244, 244, 0.8);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;
`;

const LinkOutContainer = styled.div`
    display: flex;
    align-items: center;

    ${QuestionIcon} {
        padding: 0 10px;
    }
`;

const SuggestionsContainer = styled.div<{ show: boolean }>`
    background-color: #ffffff;
    margin-top: -3px;
    width: 100%;
    max-height: 200px;
    overflow-y: scroll;
    box-sizing: border-box;
    border-left: 1px solid #0563c1;
    border-top: none;
    border-right: 1px solid #0563c1;
    border-bottom: 1px solid #0563c1;
    display: none;

    ${({ show }) =>
        show &&
        css`
            display: block;
        `};
`;

const SuggestionsTitle = styled.div`
    background-color: #f0f0f0ff;
    font-weight: bold;
    padding: 8px 10px;
`;

const SuggestionsItem = styled.div`
    padding: 8px 10px;
    font-weight: bold;
    font-size: 16px;
    line-height: 1.2;

    &:hover {
        background-color: #0563c1;
        color: #ffffff;
        cursor: pointer;
    }

    &.no-result {
        color: #c82d2d;
        font-size: 12px;
        font-weight: normal;

        &:hover {
            background-color: transparent;
            color: #c82d2d;
            cursor: inherit;
        }
    }
`;

const SelectColumn = styled.div`
    margin-bottom: 15px;
    input {
        color: #181818;
    }
`;

export {
    SuggestionsItem,
    SuggestionsTitle,
    Title,
    Error,
    SuggestionsContainer,
    UndefinedContractsWrapper,
    LinkOutContainer,
    PageSpinnerContainer,
    PageSpinnerOverlay,
    ColumnButton,
    SelectColumn,
    TitleContainer,
    PrimaryAlternativeButtonStyle,
};
